document.addEventListener('DOMContentLoaded', function () {
    const CONFIG = {
        HEADER_SELECTOR: '.hdr',
        SCROLL_CLASS: 'scroll',
        SCROLL_THRESHOLD: 100,
        MOBILE_BREAKPOINT: 840,
        SCROLL_STOP_ATTRIBUTE: 'scrollstop'
    };

    const scrollStop = document.body.dataset[CONFIG.SCROLL_STOP_ATTRIBUTE];
    if (scrollStop === '1') return;

    const header = document.querySelector(CONFIG.HEADER_SELECTOR);
    if (!header) return;

    function isDesktop() {
        const windowWidth = window.innerWidth || document.documentElement.clientWidth;
        return windowWidth > CONFIG.MOBILE_BREAKPOINT;
    }

    function updateHeader() {
        if (!isDesktop()) {
            header.classList.remove(CONFIG.SCROLL_CLASS);
            return;
        }

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > CONFIG.SCROLL_THRESHOLD) {
            header.classList.add(CONFIG.SCROLL_CLASS);
        } else {
            header.classList.remove(CONFIG.SCROLL_CLASS);
        }
    }

    updateHeader();

    window.addEventListener('scroll', updateHeader);

    let resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateHeader, 100);
    });
});
